import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import topTitle from '@/components/title.vue';
import { insureFormInfo, infoColumn } from '../utils';
import insureInfoModal from './insureInfoModal.vue';
import { policyBatchDetail } from '../request2';
import { policyBatchDetailHome } from '../request1';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    topTitle,
    insureInfoModal
  },
  data() {
    return {
      insureFormInfo,
      columns: recursionCopy(infoColumn),
      allData: [],
      data: [],
      moreShowBoolen: false,
      nowPage: 1,
      infoVisible: false,
      currentInfo: {},
      detailData: [],
      baseInfo: {}
    };
  },
  mounted() {
    this.init();
    // screen.availHeight表示屏幕高度
    // document.documentElement.scrollTop表示当前页面滚动条的位置,documentElement对应的是html标签,body对应的是body标签
    // document.compatMode用来判断当前浏览器采用的渲染方式,CSS1Compat表示标准兼容模式开启
    window.addEventListener('scroll', this.getScrollFn);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollFn);
  },
  methods: {
    getScrollFn() {
      const scrollY = document.documentElement.scrollTop || document.body.scrollTop; // 滚动条在Y轴上的滚动距离
      const vh = document.compatMode === 'CSS1Compat' ? document.documentElement.clientHeight : document.body.clientHeight; // 页面的可视高度（能看见的）
      const allHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) - 3; // 页面的总高度（所有的）
      if (scrollY + vh >= allHeight) {
        // 当滚动条滑到页面底部
        this.scrollMore();
      }
    },
    async init() {
      var _this$insureFormInfo$, _this$insureFormInfo$2, _this$insureFormInfo$3, _this$detailData;
      this.columns = recursionCopy(infoColumn);
      this.allData = [];
      this.data = [];
      let params = {
        customerId: this.$route.params.customerId,
        batchPolicyId: this.$route.params.batchPolicyId
      };
      let request = this.$store.state.user.accountInfo.customerId ? policyBatchDetail : policyBatchDetailHome;
      const res = await request(params);
      for (const key in res.baseInfo) {
        const element = res.baseInfo[key];
        this.insureFormInfo.forEach((item, index) => {
          if (item.key == key) {
            this.insureFormInfo[index].value = element;
          }
        });
      }
      if (((_this$insureFormInfo$ = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$ === void 0 ? void 0 : _this$insureFormInfo$.value) != '已投保' && ((_this$insureFormInfo$2 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$2 === void 0 ? void 0 : _this$insureFormInfo$2.value) != '部分投保' && ((_this$insureFormInfo$3 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$3 === void 0 ? void 0 : _this$insureFormInfo$3.value) != '投保失败') {
        var _JSON$parse;
        this.detailData = (_JSON$parse = JSON.parse(res.insuredInfo.originInfo)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.insuredInfo;
      } else {
        res.policyInfo.forEach(item => {
          this.detailData.push(JSON.parse(item.insuredInfo.originInfo));
        });
      }
      if ((_this$detailData = this.detailData) !== null && _this$detailData !== void 0 && _this$detailData.length) {
        var _this$detailData$, _this$insureFormInfo$4, _this$insureFormInfo$5, _this$insureFormInfo$6;
        let insuredColumn = (_this$detailData$ = this.detailData[0]) === null || _this$detailData$ === void 0 ? void 0 : _this$detailData$.insured.filter(i => i.name != '与投保人关系');
        let insuredCode = [];
        if (insuredColumn.length > 3) {
          insuredColumn = insuredColumn.slice(0, 3);
        }
        insuredColumn.forEach(item => {
          insuredCode.push(item.code);
          this.columns.splice(this.columns.length - 1, 0, {
            slots: {
              title: item.name
            },
            dataIndex: item.code,
            key: item.code,
            align: 'center',
            customRender: text => {
              return {
                children: text || '—'
              };
            }
          });
        });
        if (((_this$insureFormInfo$4 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$4 === void 0 ? void 0 : _this$insureFormInfo$4.value) != '已投保' && ((_this$insureFormInfo$5 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$5 === void 0 ? void 0 : _this$insureFormInfo$5.value) != '部分投保' && ((_this$insureFormInfo$6 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$6 === void 0 ? void 0 : _this$insureFormInfo$6.value) != '投保失败') {
          this.detailData.forEach((item, index) => {
            let obj = {};
            obj.planName = item.commonInfo.insuranceName;
            item.insured.forEach(item1 => {
              if (insuredCode.includes(item1.code)) {
                obj[item1.code] = (item1 === null || item1 === void 0 ? void 0 : item1.valData1) || (item1 === null || item1 === void 0 ? void 0 : item1.valData);
              }
            });
            this.allData.push(obj);
          });
        } else {
          this.allData = res.policyInfo;
        }
      }
      if (this.allData.length <= 20) {
        // 10条数据一页
        this.data = this.allData;
        this.moreShowBoolen = false;
      } else {
        this.data = this.allData.slice(0, 20);
        this.moreShowBoolen = true;
      }
    },
    scrollMore() {
      // 点击查询更多
      this.data = this.allData.slice(0, (this.nowPage + 1) * 20);
      this.nowPage++;
      if (this.allData.length >= this.nowPage * 20) {
        this.moreShowBoolen = true;
      } else {
        this.moreShowBoolen = false;
      }
    },
    openInfo(record, index) {
      var _this$insureFormInfo$7, _this$insureFormInfo$8, _this$insureFormInfo$9;
      this.currentInfo = recursionCopy(this.detailData[index]);
      if (((_this$insureFormInfo$7 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$7 === void 0 ? void 0 : _this$insureFormInfo$7.value) != '已投保' && ((_this$insureFormInfo$8 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$8 === void 0 ? void 0 : _this$insureFormInfo$8.value) != '部分投保' && ((_this$insureFormInfo$9 = this.insureFormInfo.find(i => i.key == 'status')) === null || _this$insureFormInfo$9 === void 0 ? void 0 : _this$insureFormInfo$9.value) != '投保失败') {
        this.baseInfo = {};
      } else {
        this.baseInfo = record;
      }
      this.infoVisible = true;
    }
  }
};